import React from 'react';
import { useModels } from './hooks';
import ModelsContent from './ModelsContent';
import ModelSettingsModal from './ModelSettingsModal';

const ModelsContainer: React.FC = () => {
  const {
    // State
    modelsState,
    selectedModelType,
    showSettingsModal,

    // Actions
    openSettings,
    closeSettings,
    saveModelSettings,
    clearError
  } = useModels();

  const selectedConfig = selectedModelType ? (modelsState[selectedModelType] ?? null) : null;

  return (
    <>
      <ModelsContent
        modelsState={modelsState}
        onOpenSettings={openSettings}
        onClearError={clearError}
      />

      <ModelSettingsModal
        isOpen={showSettingsModal}
        modelType={selectedModelType}
        config={selectedConfig}
        onClose={closeSettings}
        onSave={saveModelSettings}
      />
    </>
  );
};

export default ModelsContainer;